import AddToCart from './add-to-cart.vue';
import { createApp } from 'vue';

const getMountOptions = (element) => ({
	...(element.hasAttribute('data-show-counter') && { showCounter: true }),
	...(element.hasAttribute('data-button-text') && { buttonText: element.dataset.buttonText }),
});

export const addToCart = (element, selector) => {
	const button = element.querySelector(selector);
	if (!button) return;

	const { id } = element.dataset;
	const app = createApp(AddToCart, { id, ...getMountOptions(button) });

	app.use(window.app.pinia);
	app.mount(button);
};
